{
  "title": "Wild Cunning (UA)",
  "source": "Unearthed Arcana 36 - Starter Spells",
  "levelAndSchool": "1st-level transmutation (ritual)",
  "level": 1,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "You call out to the spirits of nature to aid you. When you cast this spell, choose one of the following effects:",
    "If there are any tracks on the ground within range, you know where they are, and you make Wisdom (Survival) checks to follow these tracks with advantage for 1 hour or until you cast this spell again.",
    "If there is edible forage within range, you know it and where to find it.",
    "If there is clean drinking water within range, you know it and where to find it.",
    "If there is suitable shelter for you and your companions within range, you know it and where to find it.",
    "Send the spirits to bring back wood for a fire and to set up a campsite in the area using your supplies. The spirits build the fire in a circle of stones, put up tents, unroll bedrolls, and put out any rations and water for consumption.",
    "Have the spirits instantly break down a campsite, which includes putting out a fire, taking down tents, packing up bags, and burying any rubbish."
  ],
  "spellLists": ["druid", "ranger"]
}
